import React from 'react';

// آیکون‌های ساده‌ی SVG برای ردیف «متد برندینگ ما»
// همه با currentColor رنگ می‌گیرند تا از رنگ متن والد پیروی کنند.

export const RadarIcon = (props) => (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="32" cy="32" r="26" stroke="currentColor" strokeWidth="2" />
        <circle cx="32" cy="32" r="17" stroke="currentColor" strokeWidth="1.5" opacity="0.6" />
        <circle cx="32" cy="32" r="8" stroke="currentColor" strokeWidth="1.5" opacity="0.6" />
        <path d="M32 32 L52 14 A26 26 0 0 1 32 58 Z" fill="currentColor" opacity="0.25" />
        <circle cx="32" cy="32" r="2.5" fill="currentColor" />
        <circle cx="22" cy="26" r="2" fill="currentColor" />
        <circle cx="40" cy="20" r="1.5" fill="currentColor" />
        <circle cx="27" cy="40" r="1.5" fill="currentColor" />
    </svg>
);

export const AudienceMapIcon = (props) => (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect x="8" y="10" width="48" height="44" rx="4" stroke="currentColor" strokeWidth="2" />
        <path d="M8 24h48M20 10v44M44 10v44" stroke="currentColor" strokeWidth="1" opacity="0.4" />
        <path d="M32 20c-6 0-10 4.3-10 9.6 0 7.4 10 16.4 10 16.4s10-9 10-16.4C42 24.3 38 20 32 20Z" fill="currentColor" opacity="0.25" stroke="currentColor" strokeWidth="2" />
        <circle cx="32" cy="29.5" r="4" fill="currentColor" />
    </svg>
);

export const CompassIcon = (props) => (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="32" cy="32" r="26" stroke="currentColor" strokeWidth="2" />
        <path d="M32 10 L38 32 L32 54 L26 32 Z" fill="currentColor" />
        <path d="M10 32 L32 26 L54 32 L32 38 Z" fill="currentColor" opacity="0.5" />
        <circle cx="32" cy="32" r="3" fill="#0D0D0D" stroke="currentColor" strokeWidth="1.5" />
    </svg>
);

export const FingerprintIcon = (props) => (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M32 14c-9 0-16 6-16 16v8c0 6 2 10 5 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M32 10c11 0 20 8 20 20v8c0 4-1 7-2.5 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M24 24c0-5 4-8 8-8s8 3 8 8v10c0 8 3 13 7 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M20 30v6c0 10 4 16 9 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M32 24c3 0 5 2 5 5v9c0 6 2 10 5 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M44 26v8c0 5 1 9 3 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export const ChatIcon = (props) => (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="32" cy="32" r="26" stroke="currentColor" strokeWidth="1.5" strokeDasharray="3 4" opacity="0.6" />
        <rect x="14" y="20" width="24" height="17" rx="4" stroke="currentColor" strokeWidth="2" />
        <path d="M18 37 L18 44 L25 37 Z" fill="currentColor" />
        <rect x="30" y="14" width="20" height="14" rx="4" stroke="currentColor" strokeWidth="2" fill="#0D0D0D" />
        <circle cx="36" cy="21" r="1.4" fill="currentColor" />
        <circle cx="40" cy="21" r="1.4" fill="currentColor" />
        <circle cx="44" cy="21" r="1.4" fill="currentColor" />
    </svg>
);
